// @flow

import Config from "../constants/Config";

export const drupalDate = {
    ID: "drupal-date",
    validate: (input: any): boolean => {
        var regex = /^(0[1-9]|[12]\d|3[01])[/\-.](0[1-9]|1[0-2])[/\-.](19|20)\d{2}$/;
        return regex.test(input.value);
    },
    error: `Please enter a valid date in the format: ${Config.frontendDateFormat}`,
};
